import * as React from "react"

import { disclosure, filterSummary, settings as labels } from "../copy"
import Disclosure from "../Disclosure"
import type { SettingsBucket } from "../types"

export default function SettingsDetails({ bucket }: { bucket: SettingsBucket }) {
  const report = bucket.filterReport
  if (!report) return null

  const clauses = report.definition?.clauses ?? []
  const failedTitles = report.failedTitles ?? []

  return (
    <div className="tw:flex tw:flex-col tw:gap-3">
      <div className="tw:flex tw:flex-col tw:gap-1.5">
        <h5 className="tw:text-sm tw:font-semibold">{labels.clausesHeading}</h5>
        {clauses.length === 0 ? (
          <p className="tw:text-sm tw:text-muted-foreground">{labels.filterEmpty}</p>
        ) : (
          <ul className="tw:flex tw:flex-col tw:gap-1.5">
            {clauses.map((clause) => (
              <li key={clause.clause} className="tw:text-sm">
                <span className="tw:font-semibold">{clause.clause}</span> {labels.clauseJoiner}{" "}
                <span className="tw:inline-flex tw:flex-wrap tw:gap-1 tw:align-middle">
                  {clause.rules.map((rule, idx) => (
                    <code
                      key={idx}
                      className="tw:rounded tw:bg-muted tw:px-1.5 tw:py-0.5 tw:font-mono tw:text-xs"
                    >
                      {rule}
                    </code>
                  ))}
                </span>
              </li>
            ))}
          </ul>
        )}
      </div>

      <p className="tw:text-sm tw:text-muted-foreground">
        {filterSummary(report.sampled ?? 0, report.passed ?? 0, report.failed ?? 0)}
      </p>

      {failedTitles.length > 0 && (
        <Disclosure label={disclosure.filteredOut}>
          <ul className="tw:flex tw:flex-col tw:divide-y tw:divide-border tw:overflow-hidden tw:rounded-lg tw:border tw:border-border tw:bg-card">
            {failedTitles.map((title, idx) => (
              <li key={idx} className="tw:px-3 tw:py-2 tw:text-sm tw:leading-5 tw:text-muted-foreground">
                {title}
              </li>
            ))}
          </ul>
        </Disclosure>
      )}
    </div>
  )
}
